const deactivateOaConfig = {
  title: 'Deactivate',
  text: 'Are you sure of deactivating #oaName (#oaMobile) OA?',
  oaName: 'OA',
  oaMobile: '9999999999'
};

export default deactivateOaConfig;
